import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { UnoStoreHooks, unoStore } from "@simulanisindia/ui";
import { BrowserRouter } from "react-router-dom";
import "./assets/css/style.scss";
import "./assets/css/responsive.scss";
// import "./assets/css/test_responsive.scss";
import "./assets/css/feedbacksurvey/feedback2.scss";
// import "./assets/css/feedbacksurvey/feedback.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/css/responsive/all_responsive.scss";

import { store } from "./store/store";
import { ModalProvider } from "./modal/context/ModalProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
const { UnoProvider } = UnoStoreHooks;
root.render(
  // <React.StrictMode>
    <UnoProvider store={unoStore}>
      <Provider store={store}>
        <BrowserRouter>
          <ModalProvider>
            <App />
          </ModalProvider>
        </BrowserRouter>
      </Provider>
    </UnoProvider>
  // </React.StrictMode>
);
